import {AiChatGeneratedAssetFilter} from '@AiChat/ai-chat.types';

export interface AiChatAssetsFiltersProps {
  filter: AiChatGeneratedAssetFilter;
  onFilterChange: (filter: AiChatGeneratedAssetFilter) => void;
}

type AssetFilterLabelKey = 'pmwjs_all' | 'pmwjs_images' | 'pmwjs_videos_capitalized';

export interface AssetFilterOption {
  filter: AiChatGeneratedAssetFilter;
  labelKey: AssetFilterLabelKey;
}

export const ASSET_FILTER_OPTIONS: AssetFilterOption[] = [
  {filter: AiChatGeneratedAssetFilter.ALL, labelKey: 'pmwjs_all'},
  {filter: AiChatGeneratedAssetFilter.IMAGES, labelKey: 'pmwjs_images'},
  {filter: AiChatGeneratedAssetFilter.VIDEOS, labelKey: 'pmwjs_videos_capitalized'},
];
